/**
 * Trae TODAS las páginas de un endpoint paginado de DRF.
 *
 * Leer sólo `res.data.results` devuelve la primera página y nada más. En el selector de
 * cuenta contable del cliente eso dejaba fuera más de la mitad de las cuentas: medido el
 * 2026-10-01 en producción hay **343 cuentas de ACTIVO** y el endpoint pagina de 50 en 50,
 * mientras las **85 cuentas de clientes (105-*) ocupan las posiciones 16 a 100** del orden
 * por código. El contador lo reportó como *"la ventana de clientes no me deja seguir
 * eligiendo las cuentas de clientes"*.
 *
 * Pide `page_size` grande para hacer pocas llamadas, y sigue mientras el backend diga que
 * hay `next`. Si una página falla, devuelve lo acumulado: media lista es más útil que
 * ninguna, y quien llama ya muestra lo que haya.
 */
export const MAX_PAGINAS = 20
export const TAMANO_PAGINA = 500

export async function traerTodasLasPaginas(api, url, params = {}, opciones = {}) {
  const { maxPaginas = MAX_PAGINAS, pageSize = TAMANO_PAGINA, onError } = opciones
  const acumuladas = []

  for (let page = 1; page <= maxPaginas; page += 1) {
    let data
    try {
      const res = await api.get(url, { params: { ...params, page_size: pageSize, page } })
      data = res?.data
    } catch (err) {
      if (onError) onError(err)
      return acumuladas
    }
    // Un endpoint sin paginar devuelve el arreglo pelón: es una sola "página".
    if (Array.isArray(data)) return [...acumuladas, ...data]
    const lista = data?.results
    if (Array.isArray(lista)) acumuladas.push(...lista)
    if (!data?.next) break
  }
  return acumuladas
}
